import { useState } from 'react';
import css from './index.module.scss';
import { emailMap } from '@/constants/delta2max';
import { useGlobal } from '@/utils/useGlobal';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import MailchimpView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';
import PolicyCheck from '@/components/PolicyCheck';
import EFUpto from '@/components/UI/svg/delta2max/EFUpto';

export default function Subscribe() {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const [popupVisible, setPopupVisible] = useState(false);
    const { t } = useLang('delta2max.teaser');
    const emailConf = emailMap[locale] || emailMap.us;

    const showPolicyCheck = [''].includes(locale);
    const [checked, setChecked] = useState(!showPolicyCheck);

    const onCheckChange = (e: any) => {
        if (e.target.checked) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    };

    return (
        <div className={`${css.Subscribe} subscribe-wrapper`}>
            {emailConf?.type === 'klaviyo' && (
                <Klaviyo
                    extra_properties={{
                        custom_source: emailConf.source,
                        $source: emailConf.source,
                        $method_type: 'Klaviyo Form',
                        $consent_version: 'Embed default text',
                        $consent_form_id: emailConf.consent_form_id,
                    }}
                    successCallback={() => {
                        // setPopupVisible(true);
                        try {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: t('sec2_sign'),
                                status: 'success',
                                tag: 'None',
                            });
                            window?.fbq && window?.fbq('track', 'Lead');
                        } catch (e) {
                            console.error(e);
                        }
                    }}
                    errorCallback={() => {
                        try {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: t('sec2_sign'),
                                status: 'fail',
                                tag: 'None',
                            });
                            window?.fbq && window?.fbq('track', 'Lead');
                        } catch (e) {
                            console.error(e);
                        }
                    }}
                >
                    <KlaviyoView list_id={emailConf.list_id} submitText={t('sec2_sign')} placeholder={t('sec2_placeholder')} disabled={!checked} />
                </Klaviyo>
            )}
            {emailConf.type === 'mailchimp' && (
                <>
                    <Mailchimp
                        successCallback={() => {
                            // setPopupVisible(true);
                            try {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_submit',
                                    button_name: t('sec2_sign'),
                                    status: 'success',
                                    tag: 'None',
                                });
                                window?.fbq && window?.fbq('track', 'Lead');
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                        errorCallback={() => {
                            try {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_submit',
                                    button_name: t('sec2_sign'),
                                    status: 'fail',
                                    tag: 'None',
                                });
                                window?.fbq && window?.fbq('track', 'Lead');
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                    >
                        <MailchimpView
                            action={emailConf.action}
                            extraFields={emailConf.extraFields}
                            submitText={t('sec2_sign')}
                            placeholder={t('sec2_placeholder')}
                            disabled={!checked}
                        />
                    </Mailchimp>
                </>
            )}
            <div className="save-icon">
                <EFUpto text={t('sec2_up_to')} width=".6rem" height=".6rem" />
            </div>
            {showPolicyCheck && <PolicyCheck onCheckChange={onCheckChange} />}
            {['us', 'ca'].includes(locale) && <p className="email-note">{t('sec2_terms')}</p>}
            <Popup
                visible={popupVisible}
                title={t('sec2_popup_title')}
                content={t.rich('sec2_popup_desc')}
                buttonText={t('sec2_popup_btn')}
                onCancel={() => setPopupVisible(false)}
                btnLink={emailConf.popupBtnLink}
            />
        </div>
    );
}
